import { React, PT, WithData, withRouter } from '@gasbuddy/react';
import moment from 'moment';
import BN from 'bignumber.js';
import { Dimmer, Loader, Table, Segment, Input, Checkbox } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';
import { rewardValue } from './util';
import { SavingsTab } from './SavingsTab';

class BaseOffers extends React.Component {
  static isNotShown(offer) {
    const now = moment();
    if (now.isBefore(offer.display_after) || (offer.display_before && now.isAfter(offer.display_before))) {
      return true;
    }
    return false;
  }

  state = {
    column: 'partner_name',
    direction: 'ascending',
    showEmpyr: true,
    showGroupon: true,
    showRakuten: true,
    showRN: true,
  }

  handleSort = clickedColumn => () => {
    const { column, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        direction: 'ascending',
      });
    } else {
      this.setState({
        direction: direction === 'ascending' ? 'descending' : 'ascending',
      });
    }
  }

  render() {
    const { column, direction, search, showExpired, showEmpyr, showGroupon, showRakuten, showRN } = this.state;
    const { data, loading, onSelected } = this.props;
    const { pending } = this.state;

    const dir = direction === 'ascending' ? 1 : -1;
    const offers = data ? (data.offers || [])
      .filter((entry) => {
        if (!showExpired && entry.display_before && moment().isAfter(entry.display_before)) {
          return false;
        }

        if ((!showEmpyr && entry.affiliate_provider_name === 'empyr')
            || (!showGroupon && entry.affiliate_provider_name === 'groupon')
            || (!showRN && entry.affiliate_provider_name === 'rewardsnetwork')
            || (!showRakuten && entry.affiliate_provider_name === 'rclon')) {
          return false;
        }

        if (!search) {
          return true;
        }

        if (search.length < 4) {
          return entry.name?.toLowerCase().startsWith(search.toLowerCase())
            || entry.internal_name?.toLowerCase().startsWith(search.toLowerCase())
            || entry.affiliate_provider_name?.toLowerCase().startsWith(search.toLowerCase());
        }
        return entry.name?.toLowerCase().includes(search.toLowerCase())
          || entry.internal_name?.toLowerCase().includes(search.toLowerCase())
          || entry.affiliate_provider_name?.toLowerCase().includes(search.toLowerCase());
      })
      .sort((a, b) => {
        switch (column) {
          case 'id':
            return (a.offer_id - b.offer_id);
          case 'internal_name':
            return (a.internal_name.localeCompare(b.internal_name)) * dir;
          case 'location_count':
            return (new BN(a.location_count || 0).comparedTo(b.location_count || 0) * dir) || ((a.internal_name.localeCompare(b.internal_name)) * dir);
          case 'affiliate_provider_name':
            return ((a.affiliate_provider_name.localeCompare(b.affiliate_provider_name)) * dir)
              || ((a.provider_identifier.localeCompare(b.provider_identifier)) * dir);
          case 'reward':
            return new BN(a.reward || 0).comparedTo(b.reward || 0) * dir;
          case 'created_at':
            return (moment(a.created_at).valueOf() - moment(b.created_at).valueOf()) * dir;
          case 'display_after':
            return (moment(a.display_after).valueOf() - moment(b.display_after).valueOf()) * dir;
          case 'display_before':
            return (moment(a.display_before).valueOf() - moment(b.display_before).valueOf()) * dir;
          default:
            return 0;
        }
      }) : [];

    return (
      <Auth forRoles={[Role.Superuser, Role.GasBackCampaigns]}>
        <Nav>
          <div>
            <h1>Card Linked Offers</h1>
            <Dimmer.Dimmable as={Segment} dimmed={loading || pending}>
              <Dimmer active={loading || pending}>
                <Loader />
              </Dimmer>
              <Table sortable striped selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan="7">
                      <Input icon="search" placeholder="Search..." onChange={(e, { value }) => this.setState({ search: value })} />
                      <Checkbox
                        style={{ marginLeft: 20 }}
                        checked={showExpired}
                        onChange={() => this.setState({ showExpired: !showExpired })}
                        label="Show expired offers"
                      />
                      <Checkbox
                        style={{ marginLeft: 20 }}
                        checked={showEmpyr}
                        onChange={() => this.setState({ showEmpyr: !showEmpyr })}
                        label="Empyr"
                      />
                      <Checkbox
                        style={{ marginLeft: 20 }}
                        checked={showGroupon}
                        onChange={() => this.setState({ showGroupon: !showGroupon })}
                        label="Groupon"
                      />
                      <Checkbox
                        style={{ marginLeft: 20 }}
                        checked={showRakuten}
                        onChange={() => this.setState({ showRakuten: !showRakuten })}
                        label="Rakuten"
                      />
                      <Checkbox
                        style={{ marginLeft: 20 }}
                        checked={showRN}
                        onChange={() => this.setState({ showRN: !showRN })}
                        label="Rewards Network"
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan="1" textAlign="right" style={{ borderLeft: 'none' }}>
                      <SavingsTab />
                    </Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell sorted={column === 'id' && direction} width={1} onClick={this.handleSort('id')}>Id</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'created_at' && direction} onClick={this.handleSort('created_at')}>Created</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'internal_name' && direction} onClick={this.handleSort('internal_name')}>Merchant Key</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'location_count' && direction} onClick={this.handleSort('location_count')}>Locations</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'affiliate_provider_name' && direction} onClick={this.handleSort('affiliate_provider_name')}>Affiliate Provider / MID</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'reward' && direction} onClick={this.handleSort('reward')}>Reward</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'display_after' && direction} onClick={this.handleSort('display_after')}>Display After</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'display_before' && direction} onClick={this.handleSort('display_before')}>Stop After</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {offers.map(d => (
                    <Table.Row
                      key={`${d.merchant_id}-${d.offer_id}`}
                      onClick={() => onSelected(d.offer_id)}
                      error={BaseOffers.isNotShown(d)}
                    >
                      <Table.Cell>{d.offer_id}</Table.Cell>
                      <Table.Cell textAlign="center">{moment(d.created_at).format('MM/DD/YYYY HH:MM:ss')}</Table.Cell>
                      <Table.Cell>{`${d.internal_name} (${d.merchant_id})`}</Table.Cell>
                      <Table.Cell textAlign="center">{d.location_count}</Table.Cell>
                      <Table.Cell textAlign="center">{`${d.affiliate_provider_name} / ${d.provider_identifier}`}</Table.Cell>
                      <Table.Cell textAlign="center">{rewardValue(d)}</Table.Cell>
                      <Table.Cell textAlign="center">{moment(d.display_after).format('MM/DD/YYYY HH:MM:ss')}</Table.Cell>
                      <Table.Cell textAlign="center">{d.display_before ? moment(d.display_before).format('MM/DD/YYYY HH:MM:ss') : '-'}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseOffers.propTypes = {
  data: PT.shape({
    campaigns: PT.arrayOf(PT.shape({
      name: PT.string,
    })),
  }),
  loading: PT.bool,
  onSelected: PT.func.isRequired,
};

BaseOffers.defaultProps = { loading: false, data: null };

export default withRouter(({ history }) => (
  <WithData url="/loyalty/clo/offers">
    <BaseOffers
      onSelected={id => history.push(`/loyalty/offers/clo/${id}`)}
    />
  </WithData>
));
